enum CallCenterCallType {
    NormalCall = 0,
    ProfessionalCall = 1
}

export { CallCenterCallType };
